import { ForceTags } from "../../../globals";

export const hasYoutubeTag = videoData => {
  return videoData.taxonomy?.tags
    ?.map(tag => tag.text)
    .includes(ForceTags.YOUTUBE);
};
